import { z } from 'zod';
import { ComponentValidator, ComponentPayloadValidator } from '../Component';

import { AbstractPort, Port } from '../fields/AbstractPort';

import { synchronize, synchronizePowerFlowDirection } from '../helpers';

import { ComponentDefinition } from '../../types/ComponentDefinition';

const port = AbstractPort.extend({
    AC: Port.AC.omit({
        power: true,
        earthingConfigurations: true,
    }).default({}),
    DC: Port.DC.omit({
        power: true,
        earthingConfigurations: true,
    }).default({}),
}).default({
    powerFlowDirection: 'bidirectional',
});

const electrical = z
    .object({
        ports: z.tuple([port, port]).default([{}, {}]),
    })
    .default({});

const DiodeValidatorBase = z.object({
    type: z.literal('diode').default('diode'),
    electrical: synchronize(synchronizePowerFlowDirection(electrical), {
        'ports.0': ['ports.1'],
    }),
});

export const DiodeValidator = ComponentValidator.merge(DiodeValidatorBase);

export const DiodePayloadValidator = ComponentPayloadValidator.merge(DiodeValidatorBase);

export const DiodeDefinition: ComponentDefinition = {
    type: 'diode',
    name: 'Diode',
    plural: 'Diodes',
    indicator: 'D',
    hasDynamicNumberOfPorts: false,
    interoperabilityDataModel: false,
    ports: {
        min: 2,
        max: 2,
        powerFlowDirections: ['input', 'output', 'bidirectional'],
        displayAsSinglePort: true,
    },
    liveData: {
        enabled: true,
        showGraphs: true,
    },
    validators: {
        component: DiodeValidator,
        payload: DiodePayloadValidator,
    },
};

export type Diode = z.infer<typeof DiodeValidator>;
export type DiodePayload = z.infer<typeof DiodePayloadValidator>;
